import { AHpsc100Type, productProperty } from 'ngx-core-services';

export const getLabels = () => ({
  localeCode: 'en-EN',
  title: 'PSC100',
  status: 'Status',
  connected: 'Connected',
  disconnected: 'Disconnected',
  deviceType: 'Device type',
  serialNumber: 'Serial number',
  actions: 'Actions',
  inverter: 'Inverter',
  devicesTitle: 'Devices',
  appFw: 'APP',
  gcpFw: 'GCP',
  pbuscco1Fw: 'PBUSCCO1',
  pbuscco2Fw: 'PBUSCCO2',
  coreFw: 'CORE',
});

export const getStatusDetails = (
  connected: boolean | undefined,
  labels: ReturnType<typeof getLabels>
): { label: string; cssClasses: string } => {
  if (connected) {
    return {
      label: labels.connected,
      cssClasses: 'bg-green-100 border-green-500 text-green-500'
    };
  }
  return {
    label: labels.disconnected,
    cssClasses: 'bg-red-100 border-red-400 text-red-400'
  };
};

export const buildPsc100Properties = (
  device: AHpsc100Type | undefined,
  labels: ReturnType<typeof getLabels>
): productProperty[] => {
  const props: productProperty[] = [];

  props.push({
    name: labels.deviceType,
    value: 'PSC100',
    icon: 'info',
    iconCssClasses: 'text-grey-400',
  });

  if (device?.app) {
    props.push({
      name: labels.appFw,
      value: device.app,
      icon: 'memory',
      iconCssClasses: 'text-grey-400',
    });
  }

  if (device?.gcp) {
    props.push({
      name: labels.gcpFw,
      value: device.gcp,
      icon: 'memory',
      iconCssClasses: 'text-grey-400',
    });
  }

  if (device?.PBUSCCO1) {
    props.push({
      name: labels.pbuscco1Fw,
      value: device.PBUSCCO1,
      icon: 'memory',
      iconCssClasses: 'text-grey-400',
    });
  }

  if (device?.PBUSCCO2) {
    props.push({
      name: labels.pbuscco2Fw,
      value: device.PBUSCCO2,
      icon: 'memory',
      iconCssClasses: 'text-grey-400',
    });
  }

  if (device?.core) {
    props.push({
      name: labels.coreFw,
      value: device.core,
      icon: 'memory',
      iconCssClasses: 'text-grey-400',
    });
  }

  return props;
};
